module.exports = __webpack_public_path__ + "ff8f1e3197792fe2ba7a91cb474c39f5.svg";